const BookQuote = ( {quote} ) => {


    var visibility;
    
    if(quote.toString() == ''){
        visibility = {display: 'none'};
    }


    return ( 
        <div className= 'single-quote' style={visibility}>
        
        
        <h3 style={{display: {visibility}}}> {quote} </h3>
            
        </div>
     );
}
 
export default BookQuote;